module.exports = __webpack_public_path__ + "img/automations.eb03632e.svg";